<template>
<div>
  <!-- div wrapper is required for router to properly function with model -->
  <div class="ui small modal" id="renewPasswordModal">
    <i class="close icon"></i>

    <div class="header">
      BIOveikals: Paroles atjaunošana
    </div>
    <div class="content">
      <div class="ui middle aligned grid">
        <div class="column">
          <div v-if="storeStatus.error != ''" class="ui negative message">
            Pārbaudi e-pastu un paroli!
          </div>
          <div v-if="resetOk" class="ui positive message">
            Parolei ir atjaunota!
          </div>
          <div class="ui  center aligned  form">
            <div class="ui  segment">
              <div class="field">
                <div class="ui left icon input">
                  <i class="user icon"></i>
                  <input v-model="credentials.email" type="email" placeholder="E-pasts">
                </div>
              </div>
              <div class="field">
                <div class="ui left icon input">
                  <i class="lock icon"></i>
                  <input v-model="credentials.password" type="password" placeholder="Parole  (min. 8 simboli)">
                </div>
              </div>
              <div class="field">
                <div class="ui left icon input">
                  <i class="lock icon"></i>
                  <input v-model="credentials.password_confirmation" type="password" placeholder="Parole atkārtoti (min. 8 simboli)" @keyup.enter="resetPassword">
                </div>
              </div>
              <button v-on:click="resetPassword" :disabled="credentials.email == '' || credentials.password == '' || credentials.password_confirmation == ''" class="ui fluid large custom_brown button" v-bind:class="{ loading: storeStatus.loading }">Atjaunot paroli</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {

  data() {
    return {
      credentials: {
        email: '',
        password: '',
        password_confirmation: '',
        token: ''
      },
      showModal:true,
      resetOk:false
    }
  },

  computed: {
    storeStatus() {
      return this.$store.state.userStore.status
    }
  },


  activated: function() {

    //set token from url
    this.credentials.token = (this.$route.params.token) ? this.$route.params.token : '';

    this.resetOk = false;
    //clear previous token and user data
    this.$store.dispatch('logoutUser');


    var self = this;
    $('#renewPasswordModal')
      .modal({
        blurring: true,
        onHidden: function(){
          //console.log('ir')
          self.$router.push({
            name: 'login'
          });
        },
      })
      .modal('setting', 'closable', false)
      .modal('show');
  },


  methods: {


    resetPassword() {

     this.$store.dispatch('resetPassword', this.credentials).then((response) => {
        this.credentials.email = ""; //reset credentials so that they dont hang in local component state
        this.credentials.password = "";
        this.credentials.password_confirmation = "";
        this.credentials.token = "";
        this.resetOk = true;
        $('#renewPasswordModal').modal('hide all'); //will trigger navigatin to login page


      }).catch((error) => {
        this.resetOk = false;
      });

    },

  }

}
</script>

<style>
.ms-pointer {
  cursor: pointer
}
</style>



// WEBPACK FOOTER //
// RenewPassword.vue?608626c6